export default __webpack_public_path__ + "static/media/menu_top_users.da1e3683.svg";